
import { Component, Vue } from "vue-property-decorator";
import {
  DeviceDetails,
  ServicePoint,
  ServicePointBalance,
  ServicePointLastTransaction,
  ServicePointLastTransactions,
} from "@/entities";
import ServicePointDetailHeader from "./components/ServicePointDetailHeader.vue";
import ServicePointDetailBalance from "./components/ServicePointDetailBalance.vue";
import ServicePointDetailLastTransactions from "./components/ServicePointDetailLastTransactions.vue";
import ServicePointDetailDeviceDetails from "./components/ServicePointDetailDeviceDetails.vue";
import { ButtonBackToDashboard } from "@/common/components";
import { DEVICE_TYPE_RE, DEVICE_TYPE_RECYCLER } from "@/pages/dashboard/dashboard.type";

@Component({
  name: "service-point-detail-page",
  components: {
    ServicePointDetailHeader,
    ServicePointDetailBalance,
    ServicePointDetailLastTransactions,
    ServicePointDetailDeviceDetails,
    ButtonBackToDashboard,
  },
})
export default class ServicePointDetailPage extends Vue {
  balanceId: string;
  servicePointBalance: ServicePointBalance | null = null;
  servicePointLastTransactions: ServicePointLastTransaction[];
  deviceDetails: DeviceDetails | null = null;
  servicePointId: string;
  servicePoint: ServicePoint | null = null;

  constructor() {
    super();
    this.servicePointLastTransactions = [];
    this.balanceId = this.$route.params.balanceId;
    this.servicePointId = "-";
  }

  created(): void {
    this.$services.servicePointBalance.fetchServicePointByIdV2(this.balanceId).then((resp) => {
      this.servicePointBalance = resp;
      this.servicePointId = resp.servicePointId;
      if (this.servicePointId) {
        this.$services.servicePointTransactions
          .fetchServicePointLastTransactionsByServicePointId(this.servicePointId)
          .then((resp2: ServicePointLastTransactions) => {
            this.servicePointLastTransactions = resp2.servicePointLastTransactions;
          });
        this.$services.servicePoints.fetchServicePointById(this.servicePointId).then((resp3: ServicePoint) => {
          this.servicePoint = resp3;
          if (this.servicePoint.deviceDetails) {
            this.deviceDetails = new DeviceDetails(this.servicePoint.deviceDetails);
          }
        });
      }
    });
  }
  get mustDisplayDetail(): boolean {
    return (
      this.servicePointBalance !== null &&
      !(
        this.servicePointBalance!.deviceType.toUpperCase() === DEVICE_TYPE_RE ||
        this.servicePointBalance!.deviceType.toUpperCase() === DEVICE_TYPE_RECYCLER
      ) &&
      this.servicePointBalance!.balances.length > 0
    );
  }
}
